/* Elico homepage sections (EU launch theme), 2026-10-18.
   Behaviour ported from the approved mockup (projects/website/eu-store-merge/outputs/2026-10-18-homepage-mockup).
   Everything is progressive: markup works without JS (all announcement messages, first tab, resting counter number).
   Init runs on DOMContentLoaded and again for a section loaded in the theme editor (shopify:section:load). */
(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  if (routes.slice(-1) !== '/') routes += '/';

  /* ---------- Announcement rotation (below 990 px; desktop shows every message) ---------- */
  function initAnnounce(root) {
    root.querySelectorAll('[data-eh-announce]').forEach(function (rot) {
      if (rot.dataset.ehInit === '1') return;
      rot.dataset.ehInit = '1';
      var slides = Array.prototype.slice.call(rot.querySelectorAll('[data-eh-slide]'));
      if (slides.length < 2) return;
      var i = 0;
      var desktop = window.matchMedia('(min-width: 990px)');
      var show = function () { slides.forEach(function (s, n) { s.hidden = !desktop.matches && n !== i; }); };
      show();
      var every = parseInt(rot.dataset.interval, 10) || 4000;
      setInterval(function () { if (!desktop.matches) { i = (i + 1) % slides.length; show(); } }, every);
      if (desktop.addEventListener) desktop.addEventListener('change', show);
    });
  }

  /* ---------- Tabs (Så fungerar det); the button under the steps follows the active tab ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-eh-tabs]').forEach(function (set) {
      if (set.dataset.ehInit === '1') return;
      set.dataset.ehInit = '1';
      var tabs = Array.prototype.slice.call(set.querySelectorAll('[role="tab"]'));
      var panels = tabs.map(function (t) { return set.querySelector('#' + t.getAttribute('aria-controls')); });
      var cta = set.querySelector('[data-eh-tab-cta]');
      tabs.forEach(function (tab, idx) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t, n) {
            t.setAttribute('aria-selected', String(n === idx));
            if (panels[n]) panels[n].hidden = n !== idx;
          });
          if (cta) {
            if (tab.dataset.cta) cta.textContent = tab.dataset.cta;
            if (tab.dataset.href) cta.setAttribute('href', tab.dataset.href);
          }
        });
      });
    });
  }

  /* ---------- Scroll-snap carousels: arrows (desktop) and dots (mobile) ---------- */
  function initCarousels(root) {
    root.querySelectorAll('[data-eh-carousel]').forEach(function (c) {
      if (c.dataset.ehInit === '1') return;
      c.dataset.ehInit = '1';
      var track = c.querySelector('[data-track]');
      var prev = c.querySelector('[data-prev]');
      var next = c.querySelector('[data-next]');
      var progress = c.querySelector('[data-progress]');
      var dots = [];
      if (!track) return;
      if (progress) {
        Array.prototype.forEach.call(track.children, function (slide, n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'eh-reviews__dot';
          b.setAttribute('aria-label', (n + 1) + ' / ' + track.children.length);
          b.addEventListener('click', function () { track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
          progress.appendChild(b);
          dots.push(b);
        });
      }
      function step() {
        var slide = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
        if (progress) {
          progress.hidden = !(max > 4);
          var cur = Math.round(track.scrollLeft / step());
          dots.forEach(function (b, n) { b.classList.toggle('eh-active', n === cur); });
        }
      }
      if (prev) prev.addEventListener('click', function () { var per = Math.max(1, Math.floor(track.clientWidth / step())); track.scrollBy({ left: -step() * per, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { var per = Math.max(1, Math.floor(track.clientWidth / step())); track.scrollBy({ left: step() * per, behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  }

  /* ---------- Product cards (Kom igång): swatches switch variant + image, add to cart via the theme drawer ---------- */
  function luminance(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec((hex || '').trim());
    if (!m) return 0;
    var n = parseInt(m[1], 16);
    return (0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
  }

  function initProductCards(root) {
    root.querySelectorAll('[data-eh-card]').forEach(function (card) {
      if (card.dataset.ehInit === '1') return;
      card.dataset.ehInit = '1';
      var dataEl = card.querySelector('script[data-eh-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
      var swatches = Array.prototype.slice.call(card.querySelectorAll('.eh-pc__swatch'));
      var img = card.querySelector('.eh-product-card__img');
      var nameEl = card.querySelector('[data-variant]');
      var priceEl = card.querySelector('[data-price]');
      var wasEl = card.querySelector('[data-was]');
      var btn = card.querySelector('.eh-pc__button');
      var hoverImg = card.querySelector('[data-hover-img]');
      // [ELICO 2026-10-22] the server picks the default (first in-stock variant) and marks it with data-default
      var startIdx = parseInt(card.dataset.default, 10);
      if (!(startIdx >= 0 && startIdx < variants.length)) startIdx = 0;
      var current = variants[startIdx] || null;

      swatches.forEach(function (sw) {
        sw.dataset.tone = luminance(sw.style.getPropertyValue('--eh-sw')) > 0.62 ? 'light' : 'dark';
      });

      function render() {
        if (!current || !btn) return;
        if (nameEl) nameEl.textContent = current.name || '';
        if (priceEl && current.price) priceEl.textContent = current.price;
        if (wasEl) {
          wasEl.textContent = current.was || '';
          wasEl.hidden = !current.was;
        }
        if (img && current.image) {
          img.src = current.image;
          if (current.srcset) img.srcset = current.srcset; else img.removeAttribute('srcset');
        }
        // hover image follows the variant so it never repeats the image already shown
        if (hoverImg && current.hover && hoverImg.getAttribute('src') !== current.hover) hoverImg.src = current.hover;
        swatches.forEach(function (o, i) {
          var on = i === variants.indexOf(current);
          o.classList.toggle('eh-is-active', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        btn.disabled = !current.available;
        btn.textContent = current.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
        btn.classList.toggle('is-soldout', !current.available);
      }

      swatches.forEach(function (sw, idx) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (o) { o.classList.remove('eh-is-active'); o.setAttribute('aria-pressed', 'false'); });
          sw.classList.add('eh-is-active');
          sw.setAttribute('aria-pressed', 'true');
          current = variants[idx] || current;
          render();
        });
      });

      if (btn) {
        btn.addEventListener('click', function () {
          if (!current || !current.available || btn.dataset.busy === '1') return;
          btn.dataset.busy = '1';
          btn.classList.add('is-loading');
          btn.setAttribute('aria-busy', 'true');
          fetch(routes + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
          }).then(function (res) {
            return res.json().then(function (d) { if (!res.ok) throw d; return d; });
          }).then(function () {
            // The theme's cart element listens for this event, re-renders the drawer and opens it.
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          }).catch(function () {
            btn.textContent = btn.dataset.labelError || btn.dataset.labelAdd;
            setTimeout(function () { render(); }, 2500);
          }).then(function () {
            btn.dataset.busy = '0';
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
          });
        });
      }
      render();
    });
  }

  /* ---------- Counter: count up when visible; the resting number is already in the HTML and never 0 ---------- */
  function initCounters(root) {
    var counts = root.querySelectorAll('[data-eh-count]');
    if (!counts.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function fmt(el, n) {
      var sep = el.dataset.sep == null ? ' ' : el.dataset.sep;
      return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        var end = parseInt(el.dataset.ehCount, 10);
        if (!(end > 0)) return;
        var t0 = null;
        function tick(t) {
          if (t0 === null) t0 = t;
          var k = Math.min(1, (t - t0) / 1600);
          el.textContent = fmt(el, end * (0.85 + 0.15 * (1 - Math.pow(1 - k, 3))));
          if (k < 1) requestAnimationFrame(tick); else el.textContent = fmt(el, end);
        }
        requestAnimationFrame(tick);
        setTimeout(function () { el.textContent = fmt(el, end); }, 1800);
      });
    }, { threshold: 0.6 });
    counts.forEach(function (c) { if (c.dataset.ehInit !== '1') { c.dataset.ehInit = '1'; io.observe(c); } });
  }

  /* ---------- Wide image band video: play only the visible breakpoint's video while on screen; poster only for reduced motion ---------- */
  function initRitualVideo(root) {
    root.querySelectorAll('[data-eh-ritual]').forEach(function (band) {
      if (band.dataset.ehInit === '1') return;
      band.dataset.ehInit = '1';
      var videos = Array.prototype.slice.call(band.querySelectorAll('video[data-eh-video]'));
      if (!videos.length) return;
      videos.forEach(function (v) { v.muted = true; v.defaultMuted = true; v.loop = true; v.setAttribute('playsinline', ''); });
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var onScreen = false;
      function visibleVideo() {
        return videos.filter(function (v) { return getComputedStyle(v).display !== 'none'; })[0] || null;
      }
      function sync() {
        var active = visibleVideo();
        videos.forEach(function (v) { if (v !== active && !v.paused) v.pause(); });
        if (!active) return;
        if (onScreen && !reduce.matches) {
          var p = active.play();
          if (p && p.catch) p.catch(function () { /* autoplay refused (low power mode): the poster stays */ });
        } else if (!active.paused) {
          active.pause();
        }
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { onScreen = e.isIntersecting; });
          sync();
        }, { rootMargin: '200px 0px', threshold: 0 }).observe(band);
      } else { onScreen = true; sync(); }
      var bp = window.matchMedia('(max-width: 749px)');
      [reduce, bp].forEach(function (mq) { if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync); });
    });
  }

  function init(root) {
    root = root || document;
    initAnnounce(root);
    initTabs(root);
    initCarousels(root);
    initProductCards(root);
    initCounters(root);
    initRitualVideo(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
